import { type X2jOptions, XMLParser } from 'fast-xml-parser';
import jsonata from 'jsonata';

const options = {
  ignoreAttributes: false,
  attributeNamePrefix: '@',
  trimValues: true, // remove spaces
  alwaysCreateTextNode: true,
  textNodeName: 'value'
} as const satisfies X2jOptions;

const parser = new XMLParser(options);

export const runXMLParser = (xmlFile: File, parserConfig: { query: string }) =>
  new Promise((resolve, reject) => {
    xmlFile.text().then(xmlText => {
      let parsedXml: unknown;
      try {
        parsedXml = parser.parse(xmlText, true);
      } catch (err) {
        reject(
          new Error(
            err instanceof Error ? err.message : `${err}`,
            // @ts-expect-error I will leave it like this
            {
              cause: 'notValidXML'
            }
          )
        );
      }
      const { query } = parserConfig;
      const data = jsonata(query).evaluate(parsedXml);
      if (data) {
        resolve({ data });
      } else {
        reject(
          new Error(
            'The provided query in workflow configuration could not extract any information from the XML data'
          )
        );
      }
    });
  });
